import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'

import {
  isEmail,
  isMobile,
  allowNumericOnly,
} from 'servos/formValidations'

const validateName = (userName, errors) => {
  if ( !(userName.length > 0) ) {
    errors['userName'] = I18n.t('loan_application_user.registration.errors.name.presence')
  }
}

const validateEmail = (userEmail, errors) => {
  if ( userEmail.length == 0) {
    errors['userEmail'] = I18n.t('onboarding.registration.errors.email.presence')
  }

  if ( (userEmail.length > 0 && !isEmail(userEmail)) ) {
    errors['userEmail'] = I18n.t('loan_application_user.registration.errors.email.format')
  }
}

const validateMobile = (userMobile, errors) => {
  if ( !(userMobile.length > 0) ) {
    errors['userMobile'] = I18n.t('loan_application_user.registration.errors.mobile.presence')
  }

  if (!isMobile(userMobile)) {
    errors['userMobile'] = I18n.t('loan_application_user.registration.errors.mobile.format')
  }
}

const validateField = {
  userName: validateName,
  userEmail: validateEmail,
  userMobile: validateMobile,
}

class SecondApplicantForm extends React.Component {
  state = {
    errors: {}
  }

  onChange = ({ currentTarget }) => {
    let { name, value} = currentTarget
    let { errors } = this.state

    let {
      userEmail,
      userMobile,
    } = this.props

    // re-validate attribute
    delete errors[name]
    validateField[name](value, errors)

    // build uo state for evaluate if form is valid
    let state = { ...this.props }
    state[name] = value

    this.setState({ errors })
    this.props.onApplicantChange({
      [name]: value,
      errors: {},
      secondaryValid: !!(state.userEmail && state.userMobile && Object.keys(errors).length == 0),
    })
  }

  render() {
    let errors = {
      ...this.state.errors,
      ...this.props.errors,
    }

    return(
      <div className="card card-single">
        <div className="card-header">
          Applicant 2 Details
        </div>
        <div className="card-body">
          <p>Please enter the details of the other applicant.</p>
          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="form-group">
                <label>
                  First name
                </label>
                <input
                  name="userName"
                  className={ `form-control ${presenceErrorClass(errors['userName'])}` }
                  onChange={ this.onChange }
                />
                <div className="invalid-feedback">
                  { errors['userName'] }
                </div>
              </div>
              <div className="form-group">
                <label>
                  Email address
                </label>
                <input
                  name="userEmail"
                  className={ `form-control ${presenceErrorClass(errors['userEmail'])}` }
                  onChange={ this.onChange }
                />
                <div className="invalid-feedback">
                  { errors['userEmail'] }
                </div>
              </div>
              <div className="form-group">
                <label>
                  Mobile phone
                </label>
                <input
                  name="userMobile"
                  className={ `form-control ${presenceErrorClass(errors['userMobile'])}` }
                  onChange={ this.onChange }
                  type='numeric'
                />
                <div className="invalid-feedback">
                  { errors['userMobile'] }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SecondApplicantForm;
